module.exports = __webpack_public_path__ + "img/icon-branch.fb2d9991.svg";